<main [@fadeInOut] role="main" id="main-heading" tabindex="0">
  <div class="container-fluid">
    <div class="mx-auto d-flex flex-column  main-heading-div">
      <div class="row" *ngIf="showPageContents()">
        <div class="col-sm-8 mt-3">
          <h1 tabindex="0" aria-label="Welcome message" class="extra-large">
            Welcome, {{user.name | splitWords:" ":0 }}
          </h1>
          <p role="heading" aria-label="Greeting message" tabindex="0">
            <span>
              Welcome to the Reed Tech SingleSource™ for Medical Devices for Global UDI data and submission
              management.
              This web-based application is designed to help Medical Device/IVD Manufacturers to collect and validate
              their
              UDI data, and process UDI submissions in the specific format required by each regional health authority.
              Each
              section of the application contains embedded surveys to collect your valuable feedback on user
              experience,
              with the results made available to our product team.
            </span>
            <span><br><br /></span>
            <span>
              The section below contains links to download Excel Data Collection Forms, which are used to collect
              and
              ingest data into the application. The Excel Forms are currently available in two different formats –
              column-based expansion to collect multi-value attributes/attribute groups, and row-based expansion to
              collect
              multi-value attribute/attribute groups. The application also supports XML data ingestion, using the Reed
              Tech
              SingleSource™ for Medical Devices XSD. Please contact your account manager if you would like to receive
              more
              information on XML data ingestion or APIs available for integration.
            </span>
          </p>

          <div class="table-responsive" *ngIf="customer" aria-label="Health Authorities">
            <h2 class="mb-2" *ngIf="showDocs(permissions.CanAccessChannelSupportDocuments)" tabindex="0">
              Get started.
              Download our templates and examples.
            </h2>

            <div *ngFor="let channel of filterCustomersWithNoTemplates(); let i = index; trackBy: trackByChannel" class="channel-section">
              <table class="table" [attr.aria-label]="'Documents for ' + channel.applicationVariantName">
                <thead *ngIf="showDocs(permissions.CanAccessChannelSupportDocuments)">
                  <tr>
                    <th colspan="2" class="table-header-no-bottom-border app-var-name" role="heading">
                      <span>{{channel.applicationVariantName}}</span>
                    </th>
                  </tr>
                  <tr>
                    <th [id]="'th-file-' + i" class="col-sm-5 td-heading">File</th>
                    <th [id]="'th-description-' + i" class="col-sm-7 td-heading">Description</th>
                  </tr>
                </thead>

                <tbody *ngIf="showDocs(permissions.CanAccessChannelSupportDocuments)">
                  <tr *ngFor="let doc of getDocumentsForChannel(channel.applicationVariantName); let j = index; trackBy: trackByDoc">
                    <td>
                      <a (click)="downloadDocument(doc.filename, $event)"
                         (keydown.enter)="downloadDocument(doc.filename, $event)"
                         (keydown.space)="downloadDocument(doc.filename, $event)"
                         tabindex="0"
                         [attr.aria-label]="'Download ' + doc.displayName"
                         [attr.aria-describedby]="'desc-' + i + '-' + j"
                         role="button"
                         class="download-link"
                         style="cursor: pointer;">
                        <i [class]="doc.icon" aria-hidden="true"></i>{{doc.displayName}}
                      </a>
                    </td>
                    <td [id]="'desc-' + i + '-' + j" tabindex="0">
                      {{doc.description}}
                    </td>
                  </tr>

                  <!-- Show message if no documents found -->
                  <tr *ngIf="getDocumentsForChannel(channel.applicationVariantName).length === 0">
                    <td colspan="2" class="text-muted">
                      No documents available for {{channel.applicationVariantName}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table" aria-label="Additional Resources">
              <thead>
                <tr>
                  <th id="th-additional-resources" colspan="2" class="table-header-no-bottom-border" role="heading"
                      tabindex="0">
                    Additional Resources
                  </th>
                </tr>
                <tr>
                  <th id="th-file" class="col-sm-3 td-heading">File</th>
                  <th id="th-description" class="col-sm-9 td-heading">Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <a (click)="downloadDocument('reedTechSingleSourceUserGuide.docx', $event)"
                       (keydown.enter)="downloadDocument('reedTechSingleSourceUserGuide.docx', $event)"
                       (keydown.space)="downloadDocument('reedTechSingleSourceUserGuide.docx', $event)"
                       aria-label="Download user guide (docx)"
                       role="button"
                       aria-describedby="user-guide-doc"
                       tabindex="0"
                       class="download-link"
                       style="cursor: pointer;">
                      <i class="fal fa-file-word"></i>Download user guide (docx)
                    </a>
                  </td>
                  <td id="user-guide-doc" tabindex="0">
                    Complete user guide with instructions.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-sm-4" *ngIf="customer">

          <div>
            <app-ingested-devices-chart [customer]="customer" [user]="user">
            </app-ingested-devices-chart>
          </div>
          <div>
            <app-submitted-devices-chart [customer]="customer" [user]="user">
            </app-submitted-devices-chart>
          </div>
        </div>


      </div>
    </div>
  </div>
</main>
